import React from "react";
import MyMarquee from "./MyMarquee";
import MyHeroImage from "./MyHeroImage";
import CourseListing from "./CourseListing";
import HistoryComponent from "./HistoryComponent";
import VolunteerForm from "./VolunteerForm";
import ServicesPage from "./ServicesPage";
import AntDesign from "./AntDesign";
import SlickSlider from "./SlickSlider";
import PdfViewer from "./PdfViewer";
import PalliativeCareArticles from "./PalliativeCareArticles";
import CourseApplication from "./CourseApplication";
import DisplayCourseApplications from "./DisplayCourseApplications";
import EbookPoster from "./EbookPoster";
import { Lan } from "@mui/icons-material";
import LanguageSwitcher from "./LanguageSwitcher";

const MyHomePage = () => {
  return (
    <div>
      {/* <LanguageSwitcher /> */}
         <SlickSlider/> 
           <MyMarquee />
              
      <HistoryComponent />
   <EbookPoster />
      <ServicesPage />
      <CourseListing />
      {/* <CourseApplication />  */}
      {/* <DisplayCourseApplications /> */}
      <PalliativeCareArticles/>
      <VolunteerForm />
      <AntDesign/>
    
    </div>
  );
};

export default MyHomePage;
